import React from "react";
import { Link } from "react-router-dom";
import shape1 from "../../images/title-shape-1.png";
import shape2 from "../../images/title-shape-2.png";

interface PageTitleProps {
  pageTitle: string;
  pagesub?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ pageTitle, pagesub }) => {
  return (
    <section className="wpo-page-title">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div className="wpo-breadcumb-wrap">
              <h2>{pageTitle}</h2>
              <ol className="wpo-breadcumb-wrap">
                <li>
                  <Link to="/home">Home</Link>
                </li>
                {pagesub && <li>{pagesub}</li>}
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="shape-1">
        <img src={shape1} alt="decorative shape 1" />
      </div>
      <div className="shape-2">
        <img src={shape2} alt="decorative shape 2" />
      </div>
    </section>
  );
};

export default PageTitle;
